import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/list#${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 快乐水追更`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
          {comic.category}
        </span>
        {rank !== undefined && (
          <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 font-heading text-sm text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 right-2 rounded-full bg-foreground-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
          {comic.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3 md:p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="truncate text-sm font-medium text-foreground-950 md:text-base">{comic.title}</h3>
          <span className="flex items-center gap-1 text-xs font-semibold text-accent-600 whitespace-nowrap">
            <i className="ri-star-fill" style={{ width: 13, height: 13 }} />
            {comic.rating}
          </span>
        </div>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{comic.intro}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <span className="text-xs text-foreground-500 whitespace-nowrap">已更新 {comic.chapters} 话</span>
          <span className="flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-heart-3-fill text-primary-500" style={{ width: 13, height: 13 }} />
            {(comic.likes / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </Link>
  );
}